import { MouseEvent } from 'react';
import { Link } from 'react-router-dom';
import { FormProps } from '../interfaces/formProps';
import axios from 'axios'

type ProjectCard = {
    props: FormProps['detailForm']
    imgUrl: string
    th_props: FormProps['detailForm']
    token: string | null
};


const Card = ({ props, imgUrl, th_props, token }: ProjectCard) => {

    const deleteHandle = (event: MouseEvent<HTMLButtonElement>) => {
        event.preventDefault();
        event.stopPropagation();
        if (window.confirm(`Are you sure you want to delete ${props[0].ProjectName}`)) {
            deleteRequst()
        }
        else {
            alert(`Delete ${props[0].ProjectName} is canceled`)
        }
    }

    const deleteRequst = () => {
        const projectID = props[0].ProjectId
        try {
            axios({
                method: "delete",
                url: `http://127.0.0.1:8000/project/delete/${projectID}`,
                headers: {
                    'Content-Type': 'application/json',
                    'gw-access-token': `${token}`
                }
            })
            alert(`You have been delete ${props[0].ProjectName}`)
            window.location.reload()
        } catch (error) {
            alert(`Delete ${props[0].ProjectName} is failed`)

        }
    }

    return (
        <div className="grid grid-cols-4 m-[1rem] shadow-[0_2px_20px_rgba(0,0,0,0.2)] rounded-[10px]">
            <img className="w-[300px] h-[300px]" src={imgUrl!== undefined?imgUrl:"https://media.istockphoto.com/id/1206575314/vector/image-unavailable-icon.jpg?s=612x612&w=0&k=20&c=7aypXCTzJ42V0xRHJ08Nq1K6fPgY5IB_D4fXbWloX_w="} alt="" />
            <div className="grid place-items-center w-full h-full">
                <h3 className='project-name'>{props[0].ProjectName.length > 20 ? props[0].ProjectName.substring(0, 20) + "..." : props[0].ProjectName}</h3>
            </div>
            <div className="grid place-items-center w-full h-dull">
                <h3 className='project-name'>{th_props[0].ProjectName.length > 20 ? th_props[0].ProjectName.substring(0, 20) + "..." : th_props[0].ProjectName}</h3>
            </div>
            <div className="w-full grid grid-cols-2 justify-center">
                <div className='self-center'>
                    <Link to="/projects/edit/" state={[props, th_props, token]} >
                        <button className="w-[8vw] rounded-3xl h-[8vh] transition bg-[#404042]  box-border text-white ">
                            <p className='grid h-full w-full place-content-center'>
                                Edit
                            </p>
                        </button>
                    </Link>
                </div>
                <div className='self-center'>
                    <button className="w-[8vw] rounded-3xl h-[8vh] transition bg-[#de4765] box-border text-white " id="delete-button" onClick={deleteHandle}>
                        <p className='grid h-full w-full place-content-center'>
                            Delete
                        </p>
                    </button>
                </div>

            </div>

        </div>
    );
};

export default Card;
